import { Fragment } from 'react';
import styled from 'styled-components';

export const Container = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  position: relative;
  z-index: 9999;
  @media (max-width: 991px) {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }
`;

export const SearchContainer = styled.div`
  flex: 1;
  margin-top: 20px;
`;

export const GroupField = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

export const GroupField2 = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

export const Label = styled.label`
  display: inline-block;
  font-family: 'AvenirNext';
  font-size: 14px;
  color: #3b3b3b;
  margin: 0 10px;
  @media (max-width: 991px) {
    min-width: 110px;
    text-align: right;
  }
`;

export const SmallLabel = styled.label`
  display: inline-block;
  font-family: 'AvenirNext';
  font-size: 14px;
  color: #3b3b3b;
  margin: 0 10px;
  white-space: nowrap;
  @media (max-width: 991px) {
    min-width: 110px;
    text-align: right;
  }
`;

export const Flex = styled.div`
  flex: 1;
  display: flex;
`;

export default {
  label: {
    display: 'inline-block',
    fontFamily: 'AvenirNext-Medium',
    fontSize: '14px',
    fontWeight: '500',
    color: '#3b3b3b',
    margin: '0 10px',
  },
  searchBox: {
    width: '100%',
    height: '46px',
  },
};
